import type { IntlShape } from 'react-intl'

export function getTimeBasedGreeting(intl: IntlShape): string {
  const hour = new Date().getHours()
  if (hour < 12) return intl.formatMessage({ id: 'ZyhCDANDWIPt4Bm9QKLi', defaultMessage: 'Good morning', description: 'Time-based greeting for morning hours' })
  if (hour < 18) return intl.formatMessage({ id: 'RxTY12LMdiuGlO_6BrpC', defaultMessage: 'Good afternoon', description: 'Time-based greeting for afternoon hours' })
  return intl.formatMessage({ id: 'K1nt_xU8JYc9Ry1MfI64', defaultMessage: 'Good evening', description: 'Time-based greeting for evening hours' })
}
